

export class SimCardOutputWithStatus implements ISimCardOutputWithStatus {
    /** The auto-generated id of the sim card details master */
    sim_card_details_id!: number;
    /** The auto-generated id of the branch details master */
    branch_detail_id!: number;
    /** The card number with 255 character limit */
    card_number!: string;
    /** The auto-generated id of the tariff plan master */
    tariff_plan_id!: number;
    /** The IMSI number with 255 character limit */
    imsi_number!: string;
    /** The card activation date */
    card_activation_date!: number;
    /** The card expiry date */
    card_expiry_date!: number;
    /** The GPRS last activation date */
    gprs_last_activation_date!: number;
    /** The GPRS expiry date */
    gprs_expiry_date!: number;
    /** Manage sim card of fuel type. 0 For De-active, 1 For Active */
    status!: number;
    /** The tariff plan with 255 character limit */
    tariff_plan!: string;
    /** The provider name with 255 character limit */
    provider_name!: string;
    /** The branch name with 255 character limit */
    branch!: string;
    /** The auto-generated id of the company details master */
    company_details_id!: number;
    /** The company name with 255 character limit */
    company_name!: string;

    constructor(data?: ISimCardOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sim_card_details_id = _data["sim_card_details_id"];
            this.branch_detail_id = _data["branch_detail_id"];
            this.card_number = _data["card_number"];
            this.tariff_plan_id = _data["tariff_plan_id"];
            this.imsi_number = _data["imsi_number"];
            this.card_activation_date = _data["card_activation_date"];
            this.card_expiry_date = _data["card_expiry_date"];
            this.gprs_last_activation_date = _data["gprs_last_activation_date"];
            this.gprs_expiry_date = _data["gprs_expiry_date"];
            this.status = _data["status"];
            this.tariff_plan = _data["tariff_plan"];
            this.provider_name = _data["provider_name"];
            this.branch = _data["branch"];
            this.company_details_id = _data["company_details_id"];
            this.company_name = _data["company_name"];
        }
    }

    static fromJS(data: any): SimCardOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new SimCardOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sim_card_details_id"] = this.sim_card_details_id;
        data["branch_detail_id"] = this.branch_detail_id;
        data["card_number"] = this.card_number;
        data["tariff_plan_id"] = this.tariff_plan_id;
        data["imsi_number"] = this.imsi_number;
        data["card_activation_date"] = this.card_activation_date;
        data["card_expiry_date"] = this.card_expiry_date;
        data["gprs_last_activation_date"] = this.gprs_last_activation_date;
        data["gprs_expiry_date"] = this.gprs_expiry_date;
        data["status"] = this.status;
        data["tariff_plan"] = this.tariff_plan;
        data["provider_name"] = this.provider_name;
        data["branch"] = this.branch;
        data["company_details_id"] = this.company_details_id;
        data["company_name"] = this.company_name;
        return data; 
    }
}

export interface ISimCardOutputWithStatus {
    /** The auto-generated id of the sim card details master */
    sim_card_details_id: number;
    /** The auto-generated id of the branch details master */
    branch_detail_id: number;
    /** The card number with 255 character limit */
    card_number: string;
    /** The auto-generated id of the tariff plan master */
    tariff_plan_id: number;
    /** The IMSI number with 255 character limit */
    imsi_number: string;
    /** The card activation date */
    card_activation_date: number;
    /** The card expiry date */
    card_expiry_date: number;
    /** The GPRS last activation date */
    gprs_last_activation_date: number;
    /** The GPRS expiry date */
    gprs_expiry_date: number;
    /** Manage sim card of fuel type. 0 For De-active, 1 For Active */
    status: number;
    /** The tariff plan with 255 character limit */
    tariff_plan: string;
    /** The provider name with 255 character limit */
    provider_name: string;
    /** The branch name with 255 character limit */
    branch: string;
    /** The auto-generated id of the company details master */
    company_details_id: number;
    /** The company name with 255 character limit */
    company_name: string;
}

